<form [formGroup]="formGroup">
    @if (model.id > 0) {
        <div class="detail-page-summary">
            <div class="row">
                <div class="col">
                    <div class="property"><b>{{ 'detailMain.identifierLabel' | t }}</b> {{ model.identifier }}</div>
                    <div class="property"><b>{{ 'detailMain.auditorLabel' | t }}</b> {{ model.createdBy }}</div>
                </div>
                <div class="col">
                    <div class="property">
                        <b>{{ 'detailMain.dateCreatedLabel' | t }}</b> {{ model.dateCreated | dateTimeFormat }}
                    </div>
                </div>
            </div>
        </div>
    }

    <div class="row">
        <div class="col">
            @if (overallRiskScoringListConfig) {
                <generic-list-manager
                    [config]="overallRiskScoringListConfig"
                ></generic-list-manager>
            }
        </div>
    </div>

    <div class="detail-page-card">
        <div class="detail-page-card-title">{{ 'detailMain.detailsTitle' | t }}</div>
        <div class="detail-page-card-body padded form-group-styling">
            <div class="row">
                <div class="col-12 col-xl-6 left-block">
                    <cerrix-textfield
                        [fieldLabel]="'detailMain.objectNameLabel' | t"
                        id="nameInput"
                        name="nameInput"
                        [placeholder]="'detailMain.requiredPlaceholder' | t"
                        formControlName="name"
                        dataUiid="audit-universe-name-input"
                    >
                    </cerrix-textfield>
                    <cerrix-textarea
                        [fieldLabel]="'detailMain.descriptionLabel' | t"
                        id="descriptionInput"
                        name="descriptionInput"
                        formControlName="description"
                        dataUiid="audit-universe-description-input"
                    >
                    </cerrix-textarea>

                    <div class="form-group">
                        <label for="impactSelect">{{ 'detailMain.impactLabel' | t }}</label>
                        <cerrix-select
                            id="impactSelect"
                            prettyName="impact"
                            bindLabel="Name"
                            bindValue="ID"
                            [getDataMethod]="standingData.impacts"
                            formControlName="impact"
                            dataUiid="audit-universe-impact-input"
                        >
                        </cerrix-select>
                    </div>
                    <cerrix-textarea
                        [fieldLabel]="'detailMain.impactCommentLabel' | t"
                        id="impactComment"
                        name="impactComment"
                        formControlName="impactComment"
                        dataUiid="audit-universe-impactcomment-input"
                    >
                    </cerrix-textarea>
                </div>
                <div class="col-12 col-xl-6 right-block">
                    <div class="form-group">
                        <label for="organizationSelect">{{ 'detailMain.organizationLabel' | t }}</label>
                        <cerrix-select-tree
                            [tree]="standingData.organizations"
                            [multiselect]="true"
                            [maxLines]="4"
                            formControlName="organizations"
                            data-uiid="audit-universe-organization-input"
                        >
                        </cerrix-select-tree>
                    </div>
                    <div class="form-group">
                        <label for="bdSelect">{{ 'detailMain.businessDimensionsLabel' | t }}</label>
                        <cerrix-select-tree
                            [tree]="standingData.businessDimensions"
                            [multiselect]="true"
                            [maxLines]="4"
                            formControlName="businessDimensions"
                            data-uiid="audit-universe-businessdimension-input"
                        >
                        </cerrix-select-tree>
                    </div>
                    <div class="form-group">
                        <label for="bdSelect">{{ 'detailMain.frameworkDimensionsLabel' | t }}</label>
                        <cerrix-select-tree
                            [tree]="standingData.frameworkDimensions"
                            [multiselect]="true"
                            [maxLines]="4"
                            formControlName="frameworkDimensions"
                            data-uiid="audit-universe-frameworkdimension-input"
                        >
                        </cerrix-select-tree>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            @if (assessmentListConfig) {
                <generic-list-manager [config]="assessmentListConfig"></generic-list-manager>
            }
        </div>
    </div>

    <div class="row">
        <div class="col">
            @if (controlEnvironmentListConfig) {
                <generic-list-manager [config]="controlEnvironmentListConfig"></generic-list-manager>
            }
            <div class="row fw-bold">
                <div class="col-1"></div>
                <div class="col-3">{{ 'detailMain.totalScore' | t }}</div>
                <div class="col-2 ms-2 text-center">
                    <span> {{ controlEnvironmentTotalScore }}</span>
                </div>
            </div>
        </div>
    </div>
</form>
